module.exports = __webpack_public_path__ + "static/media/arrow-long-right.fa39e541.svg";